'use client';
import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

import { INSIDER_CONFIRMATION_KEY } from '@constants/constants';
import { useInsiderContext } from '@contexts/insider';

const InsiderTagLoader = () => {
  const pathname = usePathname();
  const { isConfirmationScriptLoaded } = useInsiderContext();

  const loadInsiderTag = () => {
    const script = document.createElement('script');
    script.src = `//${process.env.NEXT_PUBLIC_PARTNER_NAME}.api.useinsider.com/ins.js?id=${process.env.NEXT_PUBLIC_PARTNER_ID}`;
    document.body.append(script);
  };

  useEffect(() => {
    if (pathname?.includes('/rezervasyon-ozeti')) {
      const isInsiderConfirmationScriptReady = Boolean(
        document.querySelector(`#${INSIDER_CONFIRMATION_KEY}`)
      );

      if (isInsiderConfirmationScriptReady || isConfirmationScriptLoaded) {
        loadInsiderTag();
      }
    } else {
      loadInsiderTag();
    }
  }, [pathname, isConfirmationScriptLoaded]);

  return null;
};

export default InsiderTagLoader;
